export const hslToHex = (h: number, s: number, l: number): string => {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
};

export const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return { r: 0, g: 0, b: 0 };
    }
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);
    r /= 255;
    g /= 255;
    b /= 255;
    return { r, g, b };
};

export const hexToHsl = (hex: string): { h: number; s: number; l: number } => {
    const { r, g, b } = hexToRgb(hex);
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default: {
                break;
            }
        }
        h /= 6;
    }
    return { h, s, l };
};

export const rgbaToHexA = (r: number, g: number, b: number, a: number): string => {
    let rStr = r.toString(16);
    let gStr = g.toString(16);
    let bStr = b.toString(16);
    let aStr = Math.round(a * 255).toString(16);

    if (rStr.length === 1) rStr = '0' + r;
    if (gStr.length === 1) gStr = '0' + g;
    if (bStr.length === 1) bStr = '0' + b;
    if (aStr.length === 1) aStr = '0' + a;

    return '#' + r + g + b + a;
};

export const shadeHex = (color: string, percent: number): string => {
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);

    const shade = (value: number): number => parseInt(((value * (100 + percent)) / 100).toString());
    r = shade(r);
    g = shade(g);
    b = shade(b);

    r = r < 255 ? r : 255;
    g = g < 255 ? g : 255;
    b = b < 255 ? b : 255;

    const numberToHexStr = (value: number): string => {
        const strValue = value.toString(16);
        return (strValue.length === 1 ? '0' : '') + strValue;
    };

    const rr = numberToHexStr(r);
    const gg = numberToHexStr(g);
    const bb = numberToHexStr(b);

    return '#' + rr + gg + bb;
};

export const rgbaToRgb = (r: number, g: number, b: number, a: number): string => {
    const alpha = 1 - a;
    const red = Math.round((a * (r / 255) + alpha) * 255);
    const green = Math.round((a * (g / 255) + alpha) * 255);
    const blue = Math.round((a * (b / 255) + alpha) * 255);
    return `rgb(${red}, ${green}, ${blue})`;
};

export const GHT_LEVEL_COLORS = [
    [215, 49, 70],
    [240, 149, 54],
    [245, 185, 56],
    [251, 221, 57],
    [141, 203, 73],
    [31, 186, 89],
    [37, 161, 152],
    [43, 136, 216],
];
